/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from "react";
import "./SideNav.scss";
import FisheriesIcon from "../../assets/images/fisheries_icon.png";
import HomeIcon from "../../assets/images/home_icon.svg";
import BeachesIcon from "../../assets/images/beaches_icon.svg";
import RecFishingIcon from "../../assets/images/recreational_fishing_icon.svg";
import WildlifeIcon from "../../assets/images/wildlife_tourism_icon.svg";
import TourismIcon from "../../assets/images/tourism_icon.png";
import { clearQueryStrings } from "../../hooks/queryString";

function SideNav(props) {
  const handleNavClick = (newApp) => {
    const { app, setApp } = props;
    if (app !== newApp) {
      clearQueryStrings();
      setApp(newApp);
    }
  };

  const setActiveClassName = (appItem) => {
    const { app } = props;
    if (appItem === app) {
      return "active";
    }
    return "";
  };

  return (
    <div className="appSideNav">
      <ul className="appLinks">
        <div
          onClick={() => handleNavClick("intro")}
          className={setActiveClassName("intro")}
          title="Home"
        >
          <li className="appLink">
            <img src={HomeIcon} className="svgLink" alt="Home" />
          </li>
        </div>
        <div
          onClick={() => handleNavClick("coral-rec-tourism")}
          className={setActiveClassName("coral-rec-tourism")}
          title="Coral Reef Recreation and Tourism"
        >
          <li className="appLink">
            <img
              src={TourismIcon}
              className="tourismIcon"
              alt="Coral Reef Recreation and Tourism"
            />
          </li>
        </div>
        <div
          onClick={() => handleNavClick("beach-rec-tourism")}
          className={setActiveClassName("beach-rec-tourism")}
          title="Nature-Dependent Beach Recreation and Tourism"
        >
          <li className="appLink">
            <img
              src={BeachesIcon}
              className="beachesIcon"
              alt="Nature-Dependent Beach Recreation and Tourism"
            />
          </li>
        </div>
        <div
          onClick={() => handleNavClick("rec-fishing")}
          className={setActiveClassName("rec-fishing")}
          title="Recreational Fishing"
        >
          <li className="appLink">
            <img
              src={RecFishingIcon}
              className="svgLink"
              alt="Recreational Fishing"
            />
          </li>
        </div>
        <div
          onClick={() => handleNavClick("coral-reef-fisheries")}
          className={setActiveClassName("coral-reef-fisheries")}
          title="Coral Reef Fisheries"
        >
          <li className="appLink">
            <img
              src={FisheriesIcon}
              className="fisheriesIcon"
              alt="Coral Reef Fisheries"
            />
          </li>
        </div>
        <div
          onClick={() => handleNavClick("wildlife-tourism")}
          className={setActiveClassName("wildlife-tourism")}
          title="Wildlife Tourism"
        >
          <li className="appLink">
            <img
              src={WildlifeIcon}
              className="svgLink"
              alt="Wildlife Tourism"
            />
          </li>
        </div>
      </ul>
    </div>
  );
}

export default SideNav;
